import { createTheme } from '@mui/material';
import darkScrollbar from '@mui/material/darkScrollbar';

const theme = createTheme({
  palette: {
    primary: {
      main: '#42A00E',
      dark: '#2F7D00',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#dc004e',
      contrastText: '#ffffff',
    },
    success: {
      main: '#4caf50',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    error: {
      main: '#f44336',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  zIndex: {
    drawer: 1200,
    appBar: 1100,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#42A00E',
          color: '#fff',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: (themeParam) => ({
        body: themeParam.palette.mode === 'dark' ? darkScrollbar() : null,
      }),
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '8px 16px',
        },
        contained: {
          backgroundColor: '#42A00E',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#2F7D00',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          minHeight: '48px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          '&.Mui-selected': {
            fontWeight: 700,
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: 500,
          color: '#000',
        },
        secondary: {
          fontWeight: 400,
          color: '#000',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === 'error' && {
            backgroundColor: '#FCEBE9',
            color: '#751A0C',
          }),
          ...(ownerState.severity === 'warning' && {
            backgroundColor: '#FFF6E5',
            color: '#93541B',
          }),
          ...(ownerState.severity === 'info' && {
            backgroundColor: '#E5F3FB',
            color: '#004B6F',
          }),
          ...(ownerState.severity === 'success' && {
            backgroundColor: '#E6F9ED',
            color: '#006730',
          }),
        }),
        icon: ({ ownerState }) => ({
          ...(ownerState.severity === 'error' && {
            color: '#751A0C',
          }),
          ...(ownerState.severity === 'warning' && {
            color: '#93541B',
          }),
          ...(ownerState.severity === 'info' && {
            color: '#004B6F',
          }),
          ...(ownerState.severity === 'success' && {
            color: '#006730',
          }),
        }),
      },
    },
  },
});

export default theme;
